import React, { useCallback, useEffect, useState } from "react";
import { auth, db } from "../firebase/firebaseconfig";
import { useGlobal } from "../App";
import { useLocation } from "react-router-dom";
import { setDoc,addDoc } from "firebase/firestore";
import EmptyFrame from '../Assets/EmptyFrame.png';
import { MdErrorOutline } from "react-icons/md";
import {
  calculateBogoDiscount,
  calculateCategoryDiscount,
} from "../utils/discounts";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  updateDoc,
  getDoc,
} from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";

/* ================== CONSTANTS ================== */
const FREE_SHIPPING_LIMIT = 700;
const SHIPPING_COST = 65;

export default function Cart() {
    const { showNotification } = useGlobal();
  
  const user = auth.currentUser;
  const navigate = useNavigate();
  const { coupons } = useGlobal();
  const { products } = useGlobal();

  const [cartItems, setCartItems] = useState([]);
  const [subtotal, setSubtotal] = useState(0);
  const [shipping, setShipping] = useState(SHIPPING_COST);
  const [total, setTotal] = useState(0);
  const [categoryDiscount, setCategoryDiscount] = useState(0);
  const [bogoDiscount, setBogoDiscount] = useState(0);
  const [discountTotal, setDiscountTotal] = useState(0);
  const [bogoDetails, setBogoDetails] = useState([]);
  const [animatedProgress, setAnimatedProgress] = useState(0);
  const [imageHash, setimageHash] = useState(null);
  const [notenoughcustomstickers, setnotenoughcustomstickers] = useState(false);
  const location = useLocation();
  const customproduct = location.state?.customproduct; // optional chaining


  //generate hash for custom product image



  const getUserDocRef = useCallback(async () => {
    if (!user?.email) return null;
    const q = query(collection(db, "Users"), where("User", "==", user.email));
    const snapshot = await getDocs(q);
    if (snapshot.empty) return null;
    return doc(db, "Users", snapshot.docs[0].id);
  }, [user?.email]);

  const safeParseJSON = (value, fallback) => {
    try {
      return JSON.parse(value);
    } catch (error) {
      console.error("Invalid JSON in localStorage cart:", error);
      return fallback;
    }
  };

  /* ================== FETCH CART ================== */
  useEffect(() => {
 const fetchCartItems = async () => {
    if (!user?.email) return;

    const q = query(collection(db, "Users"), where("User", "==", user.email));
    const snapshot = await getDocs(q);

    if (!snapshot.empty) {
      const cart = snapshot.docs[0].data().cart;
      console.log(cart);
    }
  };
fetchCartItems()
let isMounted = true;
    const fetchCart = async () => {
      let cartData = [];

      if (user) {
        const userRef = await getUserDocRef();
        if (userRef) {
          const userDoc = await getDoc(userRef);
          const cartallproduct = userDoc.exists() ? userDoc.data().cart || [] : [];
                    console.log("Fetched cart from Firebase:", cartallproduct);
  const customproducts = cartallproduct.filter(item => item.type === "custom");
const cartdata_0 = cartallproduct.map(cartItem => {
  const product = products.find(p => p.id === cartItem.productId || p.id === cartItem.id);
  if (!product) return null;
  return { ...product, size: cartItem.size ,count: cartItem.quantity ||cartItem.count|| 1};
}).filter(Boolean);

 console.log("cartdata_0 ", cartdata_0);


cartData = [ ...cartdata_0, ...customproducts ].filter(Boolean); 
              console.log("final", cartData);

        }
      } else {
        const storedCart = safeParseJSON(localStorage.getItem("cart"), []);
        console.log("Raw cart data from localStorage:", storedCart);
        cartData = Array.isArray(storedCart) ? storedCart : [];
        console.log("Fetched cart from localStorage:", cartData);
      }
      let matchingproducts;
    if (user){
matchingproducts = cartData
  .map(cartItem => {
    const product = products.find(item => item.id === cartItem.id);

    if (!product) return null;

    return {
      ...product,
      count: cartItem.count,
      size: cartItem.size
    };
  })
  .filter(Boolean);
    }
else {
  matchingproducts = products
  .filter(item1 =>
    cartData.some(item2 => item2.productId === item1.id|| item2.id === item1.id)
  )
  .map(item1 => {
    const cartItem = cartData.find(item2 => item2.productId === item1.id || item2.id === item1.id);
    return { 
      ...item1, 
      count: cartItem.quantity || cartItem.count || 1,
      size: cartItem.size
    };
  });
}

  console.log("testingggggggggggggggggggggggggg",matchingproducts);
const customproducts = cartData.filter(item => item.type === "custom");

const itemsWithDetails = [...matchingproducts, ...customproducts]
console.log("itemsWithDetails", itemsWithDetails);

      if (isMounted) {
        setCartItems(itemsWithDetails);
        console.log("Final cart items with details:", itemsWithDetails);
      }
    };

    fetchCart();

    return () => {
      isMounted = false;
    };
  }, [user, getUserDocRef,products]);

  /* ================== CALCULATIONS ================== */
  useEffect(() => {
    let sum = 0;
    cartItems.forEach((item) => {
      sum += (item.type === "custom" ?  item.price : item.category === "Frames" ? item.size === "30x40" ? item.bigframeprice : item.smallframeprice : item.price ) * (item.count);
    });
    setSubtotal(sum);

    const categoryResult = calculateCategoryDiscount(cartItems, coupons);
    const bogoResult = calculateBogoDiscount(cartItems, coupons);
    const totalDiscount = categoryResult.total + bogoResult.total;

    setCategoryDiscount(categoryResult.total);
    setBogoDiscount(bogoResult.total);
    setDiscountTotal(totalDiscount);
    setBogoDetails(bogoResult.details || []);

    const shippingCost = sum >= FREE_SHIPPING_LIMIT ? 0 : SHIPPING_COST;
    setShipping(shippingCost);
    setTotal(Math.max(0, sum + shippingCost - totalDiscount));
  }, [cartItems, coupons]);

  const remainingForFreeShipping = Math.max(
    0,
    FREE_SHIPPING_LIMIT - subtotal
  );
  const progressPercent =
    subtotal >= FREE_SHIPPING_LIMIT
      ? 100
      : Math.min(100, Math.round((subtotal / FREE_SHIPPING_LIMIT) * 100));
  const isHalfway = progressPercent >= 50 && progressPercent < 85;
  const isClose = progressPercent >= 85 || subtotal >= FREE_SHIPPING_LIMIT;
  const statusLabel =
    subtotal >= FREE_SHIPPING_LIMIT
      ? "Free Shipping"
      : isClose
      ? "Almost There"
      : isHalfway
      ? "Halfway"
      : "Getting Started";
  const freeShippingMessage =
    subtotal >= FREE_SHIPPING_LIMIT
      ? "🎉 Congratulations — you unlocked FREE shipping!"
      : remainingForFreeShipping <= 100
      ? "You're almost there! Add one more item to get free shipping!"
      : remainingForFreeShipping <= 200
      ? `Only ${remainingForFreeShipping} EGP left for free shipping!`
      : "Add more items to unlock free shipping.";

  useEffect(() => {
    const target = Math.max(0, Math.min(100, progressPercent));
    const timer = setTimeout(() => {
      setAnimatedProgress(target);
    }, 60);

    return () => clearTimeout(timer);
  }, [progressPercent]);

  /* ================== UPDATE FIREBASE ================== */
  const syncCart = async (updated) => {
    if (!user) {
      // Local storage - حفظ بصيغة مضغوطة
      localStorage.setItem(
        "cart",
        JSON.stringify(
          updated
        )
      );
      return;
    }

    const userRef = await getUserDocRef();
    if (!userRef) return;

    // Firebase - حفظ references فقط بدل items كاملة
    const firebaseCart = updated
   

    try {
      await updateDoc(userRef, { cart: firebaseCart });
    } catch (error) {
      console.error("Failed to sync cart:", error);
    }
  };

  // -------- REMOVE ITEM --------
  const removeItem = (item) => {
    const updated = cartItems.filter(
      (cartItem) =>
        !(
          cartItem.id === item.id &&
          cartItem.size === item.size
        )
    );
    setCartItems(updated);
    void syncCart(updated);
  };

  // -------- UPDATE QUANTITY --------
  const updateQty = (item, change) => {
    if (change == -1 && item.count == 1) {
      removeItem(item);
      return;
    }

    console.log("item",item);
    const updated = cartItems.map((cartItem) =>
      cartItem.id === item.id && cartItem.size === item.size
        ? { ...cartItem, count: cartItem.count + change }
        : cartItem
    );
    console.log("updated",updated);
    setCartItems(updated);
    void syncCart(updated);
  
  };


const gotocheckout = () => {
  console.log("Cart Items:", cartItems);

  const customproducts = cartItems.filter(i => i.type === "custom" && i.category === 'Stickers');
  console.log("Custom products count:", customproducts);
  const customproductslength = customproducts.reduce((sum,item) => sum + (item.count || item.quantity || 1),0)
  console.log("Custom products count:", customproductslength);

  if (customproductslength === 0 || customproductslength >= 15) {
    // Proceed to checkout
    navigate('/checkout', { state: { cartItems } });
  } else {
setnotenoughcustomstickers(true)    
  }
};
  /* ================== UI ================== */
  return (
    <div className="page-content cart-page">

      <div className="maxw cart-container" style={{ marginTop: "30px" }}>
        <h2 className="fw-bold">Shopping Cart</h2>

        {cartItems.length === 0 ? (
          <h3 className="text-center mt-5">Your cart is empty</h3>
        ) : (
          <>
            {/* ===== FREE SHIPPING BAR ===== */}
            <div className="freeshipping mt-4">
              <div className="freeshipping-header">
                <p className="freeshipping-message">{freeShippingMessage}</p>
                <span
                  className={`freeshipping-status ${
                    isClose ? "is-close" : isHalfway ? "is-half" : ""
                  }`}
                >
                  {statusLabel}
                </span>
              </div>

              <div className="freeshipping-progress">
                <div className="progress-bar-container">
                  <div
                    className={`progress-bar-fill ${
                      isClose ? "is-close" : isHalfway ? "is-half" : ""
                    }`}
                    style={{ width: `${animatedProgress}%` }}
                  />
                  <span
                    className={`progress-truck ${
                      animatedProgress >= 100 ? "is-complete" : ""
                    }`}
                    style={{ left: `${animatedProgress}%` }}
                  >
                    🚚
                  </span>
                  <span className="progress-percent">{animatedProgress}%</span>
                </div>

                <div className="freeshipping-meta">
                  <span className="freeshipping-label">{subtotal} EGP</span>
                  <span className="freeshipping-label">
                    {FREE_SHIPPING_LIMIT} EGP
                  </span>
                </div>
              </div>
            </div>

            {/* ===== CART LIST (All sizes) ===== */}
            <div className="cart-list">
              {cartItems.map((item) =>(
                <div key={`${item.productId || item.name}-${item.size || "default"}`} className="cart-item">
                  <div className="cart-item-main">
                   {item.type === "custom" && item.category === 'Frames' ?  <div
  className="cart-item-image"
  style={{
    position: "relative",
    display: "inline-block",
    aspectRatio: "2 / 3",
    border: "1px solid #ccc",
    borderRadius: "8px",
    overflow: "hidden",
  }}
>
  {/* Empty Frame */}
  <img
    src={EmptyFrame}
    alt="empty frame"
    style={{
      width: "100%",
      height: "100%",
      display: "block",
      objectFit: "cover",
    }}
  />

  {/* Overlay user image */}
  {item.image && (
    <img
      src={item.image}
      alt={item.name}
      style={{
        position: "absolute",
        top: "20%",
        left: "30%",
        width: "41%",
        height: "59%",
        objectFit: "cover",
        pointerEvents: "none",
      }}
    />
  )}
</div>  : 
                   <img
                      src={item.image}
                      alt={item.name}
                      className="cart-item-image"
                    />} 
                    <div className="cart-item-info">
                      <h6 className="cart-item-title">{item.type === "custom" ? item.name + (item.category === 'Frames' ? ' Custom Frame' : ' Custom Sticker') : item.name}</h6>
                      {item.size && (
                        <p className="cart-item-meta">Size: {item.size}</p>
                      )}  
                      <div className="cart-item-price">{item.type === "custom" ?  item.price : item.category === "Frames" ? item.size === "30x40" ? item.bigframeprice : item.smallframeprice : item.price } EGP</div>
                    </div>
                  </div>

                  <div className="cart-item-actions">
                    <div className="cart-qty">
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => updateQty(item, -1)}
                      >
                        -
                      </button>
                      <input
                        type="text"
                        value={item.count}
                        className="form-control form-control-sm"
                        readOnly
                      />
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => updateQty(item, 1)}
                      >
                        +
                      </button>
                    </div>
                    <button
                      className="cart-remove-link"
                      onClick={() => removeItem(item)}
                    >
                      Remove
                    </button>
                  </div>

                  <div className="cart-item-total">
                    {(item.type === "custom" ?  item.price : item.category === "Frames" ? item.size === "30x40" ? item.bigframeprice : item.smallframeprice : item.price) * item.count} EGP
                  </div>
                </div>
              ))}
            </div>

            {/* ===== SUMMARY ===== */}
            <div className="cart-summary mt-4">
              <div className="cart-summary-title">Estimate shipping</div>
              <div className="cart-summary-select">
<p className="m-0" style={{fontSize:'13px'}}>4-7 business days</p>
              </div>

              <hr />
              <div className="cart-summary-row">
                <span>Subtotal</span>
                <strong>{subtotal} EGP</strong>
              </div>
              {categoryDiscount > 0 && (
                <div className="cart-summary-row text-success">
                  <span>Category discount</span>
                  <strong>- {Math.round(categoryDiscount)} EGP</strong>
                </div>
              )}
              {bogoDiscount > 0 && (
                <div className="cart-summary-row text-success">
                  <span>
                    BOGO discount
                    {bogoDetails.length > 0 && (
                      <span style={{ marginLeft: "6px", color: "#6c757d" }}>
                        ({bogoDetails.reduce((sum, d) => sum + (d.freeQty || 0), 0)} gifts)
                      </span>
                    )}
                  </span>
                  <strong>- {Math.round(bogoDiscount)} EGP</strong>
                </div>
              )}
              {discountTotal > 0 && (
                <div className="cart-summary-row text-success">
                  <span>Total discounts</span>
                  <strong>- {Math.round(discountTotal)} EGP</strong>
                </div>
              )}
              <div className="cart-summary-row">
                <span>Shipping</span>
                <strong>{shipping === 0 ? "Free" : `${shipping} EGP`}</strong>
              </div>
              <hr />
              <div className="cart-summary-total">
                <span>Total</span>
                <span>{total} EGP</span>
              </div>
              <div className="cart-summary-actions">
                <Link to="/" className="cart-continue-link">Continue Shopping</Link>
                <button
                  className="btn btn-danger cart-checkout-btn"
                  onClick={() => gotocheckout()}
                >
                  GO TO CHECKOUT
                </button>
              </div>
              {notenoughcustomstickers && <p className="text-center mb-0 mt-2 text-danger d-flex align-items-center justify-content-center w-100 gap-1"><MdErrorOutline />
 Custom Stickers Can't be less than 15</p> }
              
            </div>
            {imageHash && console.log("Generated image hash:", imageHash)}
            {imageHash &&
            <img src={imageHash}></img>

            }
          </>
        )}
      </div>
    </div>
  );
}
